import { render, staticRenderFns } from "./v-checkbox-group.vue?vue&type=template&id=df18641c&scoped=true&"
import script from "./v-checkbox-group.vue?vue&type=script&lang=js&"
export * from "./v-checkbox-group.vue?vue&type=script&lang=js&"
import style0 from "./v-checkbox-group.vue?vue&type=style&index=0&id=df18641c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df18641c",
  null
  
)

export default component.exports